var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPercentCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.78 3.22C16.7 1.14 13.94 0 11 0C8.06 0 5.3 1.14 3.22 3.22C1.14 5.3 0 8.06 0 11C0 13.94 1.14 16.7 3.22 18.78C5.3 20.86 8.06 22 11 22C13.01 22 14.98 21.45 16.69 20.41C17.1 20.16 17.23 19.64 16.98 19.23C16.73 18.82 16.21 18.69 15.8 18.94C14.36 19.81 12.7 20.28 11 20.28C5.88 20.28 1.72 16.12 1.72 11C1.72 5.88 5.88 1.72 11 1.72C16.12 1.72 20.28 5.88 20.28 11C20.28 12.83 19.74 14.61 18.71 16.15C18.45 16.54 18.55 17.08 18.95 17.34C19.34 17.6 19.88 17.5 20.14 17.1C21.36 15.28 22 13.16 22 10.99C22 8.05 20.86 5.29 18.78 3.21V3.22Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.35001 16.05C8.48001 16.12 8.62001 16.15 8.76001 16.15C9.07001 16.15 9.36001 15.99 9.52001 15.7L14.16 7.11C14.39 6.69 14.23 6.17 13.81 5.95C13.39 5.72 12.87 5.88 12.65 6.3L8.00001 14.89C7.77001 15.31 7.93001 15.83 8.35001 16.05Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58 7.99C9.58 6.81 8.62 5.84 7.43 5.84C6.24 5.84 5.28 6.8 5.28 7.99C5.28 9.18 6.24 10.14 7.43 10.14C8.62 10.14 9.58 9.18 9.58 7.99ZM7.43 8.42C7.19 8.42 7 8.23 7 7.99C7 7.75 7.19 7.56 7.43 7.56C7.67 7.56 7.86 7.75 7.86 7.99C7.86 8.23 7.67 8.42 7.43 8.42Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.52 16.16C15.7 16.16 16.67 15.2 16.67 14.01C16.67 12.82 15.71 11.86 14.52 11.86C13.33 11.86 12.37 12.82 12.37 14.01C12.37 15.2 13.33 16.16 14.52 16.16V16.16ZM14.52 13.58C14.76 13.58 14.95 13.77 14.95 14.01C14.95 14.25 14.76 14.44 14.52 14.44C14.28 14.44 14.09 14.25 14.09 14.01C14.09 13.77 14.28 13.58 14.52 13.58Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentCircle);
export default __webpack_public_path__ + "static/media/percentCircle.fd76ac53d0a8fa183d886711bee3e437.svg";
export { ForwardRef as ReactComponent };